import React from 'react';
import Select from '../../../components/ui/Select';

const HouseSystemSection = ({ houseSystem, onHouseSystemChange, error }) => {
  const houseSystems = [
    { 
      value: 'placidus', 
      label: 'Placidus (เพลซิดัส)', 
      description: 'Most popular system in Western astrology' 
    },
    { 
      value: 'koch', 
      label: 'Koch (คอช)', 
      description: 'Birthplace-based system' 
    },
    { 
      value: 'equal', 
      label: 'Equal House (เท่ากัน)', 
      description: 'Each house spans exactly 30 degrees' 
    },
    { 
      value: 'whole-sign', 
      label: 'Whole Sign (ราศีเต็ม)', 
      description: 'Ancient system using complete zodiac signs' 
    },
    { 
      value: 'campanus', 
      label: 'Campanus (แคมปานัส)', 
      description: 'Prime vertical division system' 
    },
    { 
      value: 'regiomontanus', 
      label: 'Regiomontanus (เรจิโอมอนทานัส)', 
      description: 'Celestial equator-based system' 
    },
    { 
      value: 'porphyry', 
      label: 'Porphyry (พอร์ฟิรี)', 
      description: 'Simple trisection method' 
    },
    { 
      value: 'morinus', 
      label: 'Morinus (โมรินัส)', 
      description: 'Equatorial system' 
    },
    { 
      value: 'topocentric', 
      label: 'Topocentric (โทโพเซนทริก)', 
      description: 'Modified Placidus system' 
    },
    { 
      value: 'alcabitius', 
      label: 'Alcabitius (อัลคาบิเทียส)', 
      description: 'Medieval Arabic system' 
    }
  ];

  return (
    <div className="space-y-4 md:space-y-6">
      <div>
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-3 md:mb-4">
          ระบบบ้าน
        </h3>
        <p className="text-xs md:text-sm text-muted-foreground mb-4">
          House System Selection
        </p>
      </div>

      <Select
        label="เลือกระบบบ้าน"
        description="Select the house division system for chart calculation"
        options={houseSystems}
        value={houseSystem}
        onChange={onHouseSystemChange}
        error={error}
        required
        searchable
        placeholder="เลือกระบบบ้าน..."
      />
    </div>
  );
};

export default HouseSystemSection;